import React, { Fragment } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { AxiosAPI } from '../../../../../helpers/AxiosAPI';
import { putAPI_UpdateMissedResponseStatus } from '../../../../../constants/APIs';

const UpdateStatus = ({
    id,
    value,
    userName
}) => {
    const handleUpdateStatus = () => {
        var body = {
            CurrentStatus: value,
            StatusUpdatedBy: userName
        }
        AxiosAPI({
            method: 'put',
            url: `${putAPI_UpdateMissedResponseStatus}/${id}`,
            data: body,
        }).then(
            (res) => {
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            },
            (error) => {
                console.log(error);
            }
        );
    }
    return (<Fragment>
        <Button className="ml-2" size="xs" color={value === "Updated" ? "success" : "info"}
            onClick={() => handleUpdateStatus()}>{value}</Button>
    </Fragment>)
}

const mapStateToProps = ({ settings }) => {
    const { userName } = settings;
    return { userName };
};
export default injectIntl(
    connect(mapStateToProps, {})(UpdateStatus)
);